import { useUpdateEffect } from 'ahooks';
import * as React from 'react';
import { IApiaFilter } from './ApiaFilter';
import { ApiaUtil, DateInput } from '@apia/components';
import { getLabel } from '@apia/util';

const ApiaDateFilter = ({
  filter,
  onChange,
  onBlur,
  className,
  onDateError,
}: IApiaFilter & {
  onDateError?: (error: string, addDateType?: boolean) => unknown;
}) => {
  const [value, setValue] = React.useState<string>(String(filter.currentValue));
  const lastDispatchedValue = React.useRef<any>(null);

  useUpdateEffect(() => {
    lastDispatchedValue.current = filter.currentValue;
    setValue(filter.currentValue as string);
  }, [filter.currentValue]);

  React.useEffect(() => {
    if (filter.currentValue === '') {
      lastDispatchedValue.current = filter.currentValue;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter?.deleteFiltersTimestamp]);

  const handleOnChange = React.useCallback(
    async (ev: string | null) => {
      if (onChange && ev !== lastDispatchedValue.current) {
        const result = onChange(String(ev));
        if (result === true) {
          setValue(ev ?? '');
          lastDispatchedValue.current = ev;
        }
        return typeof result === 'string' ? result : null;
      }
      return null;
    },
    [onChange],
  );
  const handleOnBlur = React.useCallback(
    async (ev: string | null) => {
      if (onBlur && ev !== lastDispatchedValue.current) {
        const value = (await onChange?.(ev ?? '')) || true;
        if (value === true) {
          lastDispatchedValue.current = ev;
        }
        //   return value;
      } else if (ev === '' && lastDispatchedValue.current === '') {
        const value = (await onChange?.(ev ?? '')) || true;
        if (value === true) {
          lastDispatchedValue.current = ev;
        }
      }
      // return true;
    },
    [onBlur, onChange],
  );
  const handleOnError = React.useCallback(
    (error: string) => {
      ApiaUtil.instance.notifications.notify({
        message: error,
      });
      if (onDateError) {
        onDateError(error, error === getLabel('msgInvalidDate').text);
      }
    },
    [onDateError],
  );

  return (
    <DateInput
      className={`filter__date ${className ?? ''} ${
        filter.error ? 'field__withError' : ''
      }`}
      value={value}
      data-test-id={`filter-${filter.id}`}
      aria-label={filter.toolTip}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      readonly={filter.readonly}
      onError={handleOnError}
    />
  );
};

export default React.forwardRef(ApiaDateFilter);
